import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpp66lxhdn/layouts/custom.vue").then(m => m.default || m))
}